import { setQuery } from 'hobbit-base/modules/utils';

/**
 * 国际化IM-SDK v2.1
 */
const IntlIMSDK = class {
  constructor(initConfig) {
    this.config = null;
    this.initedCallback = null;
    this.imFrameID = 'intl_im_frame';
    // 发送消息到IM Frame的Action
    this.POST_MESSAGE_ACTION = {
      IM_SHOW: 'intl_im_show', // tab:0/1
      IM_HIDE: 'intl_im_hide',
      IM_SEND_MESSAGE: 'intl_im_send',
    };

    // 接收消息来自IM Frame的Action
    this.RECEIVE_MESSAGE_ACTION = {
      IM_INIT: 'intl_im_init', // IM窗口初始化完成（消息检测之前）
      IM_LOAD: 'intl_im_load', // IM加载完成（消息检测完成）（type: 0未登录，1无消息，2有消息）
      NEW_MESSAGE: 'intl_im_message', // 新消息 (newMsgs: 新消息集合)
      IM_CLOSE: 'intl_im_close', // IM窗口关闭
      IM_ERROR: 'intl_im_error', // IM报错 (errCode, errMsg)
      IM_NEED_SIGNIN: 'intl_im_need_signin', // 需要登录
      IM_MEDIA_SHOW: 'intl_im_media_show', // 播放或显示媒体资源消息（type：媒体类型，url：媒体地址）
    };

    if (initConfig) {
      this.lazyInit(initConfig);
    }
  }

  /**
   * 惰性初始化
   */
  lazyInit(initConfig) {
    this.config = {
      imUrl: '/faqim/',
      intlImFrameClass: 'intl-im-frame',
      onMessage: msgs => 0,
      onLoad: type => 0,
      onClose: () => 0,
      onError: (errCode, errMsg) => 0,
      onNeedSignIn: () => 0,
      onMediaShow: (type, url) => {
        if (!url) return;
        window.open(url, 'img_pic_view');
      },
      ...initConfig,
    };

    this.addMessageEventListener();
    this.imFrame = this.createIMFrame();
    return new Promise(resolve => {
      this.initedCallback = resolve;
    });
  }

  createIMFrame() {
    let imFrame = document.getElementById(this.imFrameID);
    if (imFrame) {
      return imFrame;
    }
    imFrame = document.createElement('iframe');
    imFrame.setAttribute('id', this.imFrameID);
    imFrame.setAttribute('src', this.config.imUrl);
    imFrame.className = this.config.intlImFrameClass;
    document.body.appendChild(imFrame);
    return imFrame;
  }

  addMessageEventListener() {
    this.messageEventFn = this.messageEventFn.bind(this);
    // 监听IM消息
    window.addEventListener('message', this.messageEventFn, false);
  }

  messageEventFn(e) {
    switch (e.data.action) {
      case this.RECEIVE_MESSAGE_ACTION.IM_INIT:
        if (this.initedCallback) this.initedCallback();
        break;
      case this.RECEIVE_MESSAGE_ACTION.NEW_MESSAGE:
        this.config.onMessage.call(e, e.data.newMsgs);
        break;
      case this.RECEIVE_MESSAGE_ACTION.IM_CLOSE:
        this.hideIM();
        this.config.onClose.call(e);
        break;
      case this.RECEIVE_MESSAGE_ACTION.IM_LOAD:
        this.config.onLoad.call(e, e.data.type);
        break;
      case this.RECEIVE_MESSAGE_ACTION.IM_ERROR:
        this.config.onError.call(e, e.data.errCode, e.data.errMsg);
        break;
      case this.RECEIVE_MESSAGE_ACTION.IM_NEED_SIGNIN:
        this.config.onNeedSignIn.call(e, e.data.type);
        break;
      case this.RECEIVE_MESSAGE_ACTION.IM_MEDIA_SHOW:
        this.config.onMediaShow.call(e, e.data.type, e.data.url);
        break;
      default:
        break;
    }
  }

  destroyed() {
    window.removeEventListener('message', this.messageEventFn, false);
    const imFrame = document.getElementById(this.imFrameID);
    if (imFrame) {
      document.body.removeChild(imFrame);
    }
  }

  showIM(tab = 1) {
    this.imFrame.contentWindow.postMessage({
      action: this.POST_MESSAGE_ACTION.IM_SHOW,
      tab,
    }, '*');
    this.imFrame.className = `${this.imFrame.className.trim()} show`;
  }

  hideIM() {
    this.imFrame.contentWindow.postMessage({
      action: this.POST_MESSAGE_ACTION.IM_HIDE,
    }, '*');
    this.imFrame.className = this.imFrame.className.replace(/show/ig, '');
  }

  sendMessage(content, contentType) {
    this.imFrame.contentWindow.postMessage({
      action: this.POST_MESSAGE_ACTION.IM_SEND_MESSAGE,
      content,
      contentType,
    }, '*');
  }
};

export default IntlIMSDK;
